import { ticketsConditions } from './conditions'
import { ticketsScenarios } from './steps'
import { ticketsTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const ticketsOnboarding: IOnboardingModule = {
  scenarios: ticketsScenarios,
  texts: ticketsTexts,
  conditions: ticketsConditions,
}
